// extracted by mini-css-extract-plugin
export default {"container":"Ready_container__wsPXE","wrapper":"Ready_wrapper__iBfzd"};